export enum ServiceLevelCode {
  BKTR = 'BKTR',
  EAPS = 'EAPS',
  EOLO = 'EOLO',
  G001 = 'G001',
  G002 = 'G002',
  G003 = 'G003',
  G004 = 'G004',
  G005 = 'G005',
  G006 = 'G006',
  G007 = 'G007',
  G009 = 'G009',
  INST = 'INST',
  IRCA = 'IRCA',
  NPCA = 'NPCA',
  NUGP = 'NUGP',
  NURG = 'NURG',
  PRPT = 'PRPT',
  SDVA = 'SDVA',
  SEPA = 'SEPA',
  SPLI = 'SPLI',
  SPSC = 'SPSC',
  SRTP = 'SRTP',
  SVAT = 'SVAT',
  SVDE = 'SVDE',
  URGP = 'URGP',
  URNS = 'URNS',
  WFSM = 'WFSM',
}
